import { render, staticRenderFns } from "./cod_online_order_report.vue?vue&type=template&id=1485c2b2&"
import script from "./cod_online_order_report.vue?vue&type=script&lang=js&"
export * from "./cod_online_order_report.vue?vue&type=script&lang=js&"
import style0 from "./cod_online_order_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports